import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axiosAdmin from "../../../../api/apiAdmin";
import LogsItem from "./LogsItem";
import PackItem from "./PackItem";
import TransactionsItem from "./TransactionsItem";
import { BsSearch } from "react-icons/bs";

const Archive = () => {
    const { t } = useTranslation();
    //data
    const [data, setData] = useState([]);
    //err
    const [error, setError] = useState(null);
    //archive options
    const archiveOptions = [
        { key: "transactions", label: t("admin_transactions") },
        { key: "logs", label: t("admin_logs") },
        { key: "package_history", label: t("admin_package_history") }
    ];
    //current option
    const [currentOption, setCurrentOption] = useState("transactions");
    //loaded ended
    const [isLoaded, setIsLoaded] = useState(false);
    //search value
    const [searchValue, setSearchValue] = useState("");

    //fetch transactions
    const handleTransactionsFetch = async () => {
        setIsLoaded(false);
        try {
            const res = await axiosAdmin.get(`/transactions`);
            setData(res.data.data);
            setIsLoaded(true);
        } catch (err) {
            setError(err);
        }
    }

    //fetch logs
    const handleLogsFetch = async () => {
        setIsLoaded(false);
        try {
            const res = await axiosAdmin.get(`/logs`);
            setData(res.data.data);
            setIsLoaded(true);
        } catch (err) {
            setError(err);
        }
    }

    //fetch packHistory
    const handlePackHistoryFetch = async () => {
        setIsLoaded(false);
        try {
            const res = await axiosAdmin.get(`/packHistory?search=${searchValue}`);
            setData(res.data.data);
            setIsLoaded(true);
        } catch (err) {
            setError(err);
        }
    }

    //logs data from api
    useEffect(() => {
        if (currentOption === "transactions") {
            handleTransactionsFetch();
        } else if (currentOption === "logs") {
            handleLogsFetch();
        } else if (currentOption === "package_history") {
            handlePackHistoryFetch();
        }
    }, [currentOption, searchValue]);

    return (
        <div className="xl:ml-[280px] mt-[55px] bg-slate-100 dark:bg-slate-900
            min-h-screen p-10 sm:p-5 pb-24 sm:pb-24 ">
            <div>
                <div className="w-full flex gap-1 items-center">
                    {archiveOptions.map((item, index) => {
                        return (
                            <div className={`px-2 py-3 rounded-lg shadow-md border border-gray-300
                            ${currentOption === item.key ? "bg-green-300" : "bg-white dark:bg-slate-800"} cursor-pointer`}
                                key={index}
                                onClick={() => { setCurrentOption(item.key); setData([]) }}
                            >
                                <p className={`text-sm font-bold text-slate-500 ${currentOption === item.key && "text-white"}`}>
                                    {item.label}
                                </p>
                            </div>
                        )
                    })}
                </div>
                {currentOption === "package_history" &&
                    <div className="w-full flex justify-between sm:flex-wrap sm:gap-3 mt-5">
                        <div className="w-full flex justify-between gap-1 sm:w-full">
                            <div className="pv-2 flex items-center hover:outline-slate-400 hover:outline-2
                hover:outline gap-x-1  px-3.5 py-1 rounded-lg dark:bg-slate-800 border-gray-300
                border dark:border-slate-600 w-full bg-white">
                                <input
                                    type="search"
                                    placeholder={t("admin_search_placeholder")}
                                    className="w-full h-8 pl-1.5 focus:outline-none dark:text-white
                                    dark:bg-slate-800 border-0"
                                    onChange={(e) => { setSearchValue(e.target.value) }}
                                    value={searchValue}
                                />
                            </div>
                        </div>
                    </div>
                }
                <div className="w-full mt-5 flex flex-col gap-2">
                    {isLoaded &&
                        <>
                            {currentOption === "transactions" &&
                                data.map((item, index) => {
                                    return (
                                        <TransactionsItem
                                            key={index}
                                            itemData={item}
                                        />
                                    )
                                })
                            }
                            {currentOption === "logs" &&
                                data.map((item, index) => {
                                    return (
                                        <LogsItem
                                            key={index}
                                            itemData={item}
                                        />
                                    )
                                })
                            }
                            {currentOption === "package_history" &&
                                data.map((item, index) => {
                                    return (
                                        <PackItem
                                            key={index}
                                            itemData={item}
                                        />
                                    )
                                })
                            }
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default Archive;